'use client';

import dynamic from 'next/dynamic';

export const FloatingGiftBoxControllerMount = dynamic(
  () =>
    import('./FloatingGiftBoxController').then(
      ({ FloatingGiftBoxController }) => FloatingGiftBoxController,
    ),
  { ssr: false },
);
